import { graphql } from "@/lib/gql/__generated__";

export const CampaignDelete_TopPage_Mutation = graphql(/* GraphQL */ `
	mutation CampaignDelete_TopPage($hotelID: ID!, $voucherID: ID!) {
		voucherForCampaignDelete(hotelID: $hotelID, voucherID: $voucherID) {
			userErrors
			message
		}
	}
`);
